
import React from "react";
import { Mail } from "lucide-react";
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableHead, 
  TableHeader, 
  TableRow 
} from "@/components/ui/table";
import { LetterActions } from "./LetterActions";
import { Card } from "@/components/ui/card";

interface Letter {
  id: string;
  delivery_date: string;
  plan_type: string | null;
  owner_email: string;
}

interface AvailableLettersTableProps {
  letters: Letter[];
  isAdmin: boolean;
  onView: (id: string) => void;
  onShare: (id: string) => void;
  onDownload: (id: string) => void;
  onDelete: (id: string) => void;
}

export function AvailableLettersTable({
  letters,
  isAdmin,
  onView,
  onShare,
  onDownload,
  onDelete
}: AvailableLettersTableProps) {
  const formatDate = (date: string) => {
    // Força a data como local adicionando "T00:00:00" para evitar problemas de fuso horário
    const d = new Date(date + "T00:00:00");
    return d.toLocaleDateString("pt-BR");
  };

  return (
    <Card className="overflow-hidden">
      <Table>
        <TableHeader className="bg-gray-50">
          <TableRow>
            <TableHead className="font-semibold">Data de Entrega</TableHead>
            <TableHead className="font-semibold">Status</TableHead>
            <TableHead className="font-semibold">Plano</TableHead>
            {isAdmin && <TableHead className="font-semibold">Email</TableHead>}
            <TableHead className="text-right font-semibold">Ações</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {letters.map((letter) => (
            <TableRow key={letter.id} className="hover:bg-gray-50 transition-colors">
              <TableCell>
                <div className="flex items-center gap-2">
                  <Mail className="h-4 w-4 text-green-500" />
                  {formatDate(letter.delivery_date)}
                </div>
              </TableCell>
              <TableCell>
                <span className="px-2 py-1 rounded-full text-xs bg-green-100 text-green-800">
                  Disponível
                </span>
              </TableCell>
              <TableCell className="capitalize">{letter.plan_type || "Padrão"}</TableCell>
              {isAdmin && <TableCell>{letter.owner_email}</TableCell>}
              <TableCell>
                <LetterActions
                  letterId={letter.id}
                  onView={onView}
                  onShare={onShare}
                  onDownload={onDownload}
                  onDelete={onDelete}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  );
}
